import Home from "../views/home/home.vue";
import Products from "../views/products/index.vue";
import Bazi from "../views/products/bazi.vue";
import Xunbu from "../views/products/xunbu.vue";
import About from "../views/about/about.vue";

export default [
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/products",
    name: "products",
    component: Products,
    redirect: "/products/bazi",
    meta: {
      title: "产品介绍",
    },
    children: [
      {
        path: "/products/bazi",
        name: "bazi",
        component: Bazi,
        meta: {
          title: "玄综八字",
        },
      },
      {
        path: "/products/xunbu",
        name: "xunbu",
        component: Xunbu,
        meta: {
          title: "寻卜",
        },
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    component: About,
    meta: {
      title: "关于我们",
    },
  },
];
